import { InjectionToken } from '@angular/core';

export const FOUND_ERROR_TOKEN = new InjectionToken('FOUND_ERROR');
